import Vue from "vue";
import Vuex from "vuex";
import {
  queryMyselfInfo
} from "@/services/user/index.js";
import {
  queryMyselfStore
} from "@/services/mall/store.js";
//1. 安装
Vue.use(Vuex);
var store = new Vuex.Store({
  state: {
    //TODO:登录后的token,1天失效
    storeToken: "",
    //用户信息: 导航权限 店铺权限
    userInfo: {},
    //全量导航  routerName: "Management"
    navList: [
      //系统管理
      {
        id: "0",
        label: "系统管理",
        icon: "el-icon-setting",
        routerName: "system",
        children: [{
            id: "0-1",
            label: "账号管理",
            routerName: "SysUser",
            path: "/management/system/user",
          },
          {
            id: "0-2",
            label: "角色管理",
            routerName: "AuthGroup",
            path: "/management/system/authGroup",
          },
          // {
          //   id: "0-3",
          //   label: "菜单管理",
          //   routerName: "Menu",
          //   path: "/management/supAdmin/system/menu",
          // },
        ],
      },
      //企业管理
      {
        id: "1",
        label: "企业管理",
        // icon: "el-icon-s-custom",
        icon: "el-icon-s-data",
        routerName: "SupAdmin",
        children: [
          // {
          //   id: "0-0",
          //   label: "首页",
          //   icon: "el-icon-s-data",
          //   routerName: "Dashboard",
          //   path: "/management/supAdmin/dashboard",
          //   // hide: true //隐藏导航栏配置
          // },
          {
            id: "1-1",
            label: "企业CRM-数据库",
            routerName: "Crm",
            path: "/management/fairAdmin/crm",
          },
          {
            id: "1-2",
            label: "食品展-数据库",
            routerName: "FoodExpo",
            path: "/management/fairAdmin/foodExpo",
          },
          {
            id: "1-3",
            label: "茶博会-数据库",
            routerName: "TeaData",
            children: [{
                id: "1-3-0",
                label: "展商登记(小程序)",
                routerName: "BookingBooth",
                path: "/management/fairAdmin/teaData/bookingBooth",
              },
              {
                id: "1-3-1",
                label: "观众登记(小程序)",
                routerName: "MiniRegister",
                path: "/management/fairAdmin/teaData/miniRegister",
              },
              {
                id: "1-3-2",
                label: "vip观众登记(小程序)",
                routerName: "MiniVip",
                path: "/management/fairAdmin/teaData/miniVip",
              },
              {
                id: "1-3-3",
                label: "酒店预定(网站)",
                routerName: "BookingHotel",
                path: "/management/fairAdmin/teaData/bookingHotel",
              },
              {
                id: "1-3-4",
                label: "兼职报名(网站)",
                routerName: "PtRegister",
                path: "/management/fairAdmin/teaData/ptRegister",
              },
              {
                id: "1-3-5",
                label: "展商预约兼职(网站)",
                routerName: "RequestPtStuff",
                path: "/management/fairAdmin/teaData/requestPtStuff",
              },
            ],
          },
          // {
          //   id: "1-4",
          //   label: "爱茶商城管理",
          //   routerName: "Mall",
          //   children: [
          //     // {
          //     //   id: "1-4-0",
          //     //   label: "总数据看版",
          //     //   routerName: "Dashboard",
          //     //   path: "/management/supAdmin/dashboard",
          //     // },
          //     {
          //       id: "1-4-2",
          //       label: "用户数据",
          //       routerName: "MallUser",
          //       path: "/management/supAdmin/mall/user",
          //     },
          //     {
          //       id: "1-4-3",
          //       label: "门店数据",
          //       routerName: "MallStore",
          //       path: "/management/supAdmin/mall/store",
          //     },
          //     {
          //       id: "1-4-4",
          //       label: "创建账号", //包括控制门店的数量
          //       routerName: "MallAdmin",
          //       path: "/management/supAdmin/mall/admin",
          //     },
          //   ],
          // },
        ],
      },
      //小程序管理
      {
        id: "2",
        label: "小程序管理",
        // icon: "el-icon-s-data",
        icon: "el-icon-s-platform",
        // icon: "el-icon-s-shop",
        routerName: "Mall",
        children: [
          // {
          //   id: "1-4-0",
          //   label: "总数据看版",
          //   routerName: "Dashboard",
          //   path: "/management/supAdmin/dashboard",
          // },
          {
            id: "2-1",
            label: "用户数据",
            routerName: "MallUser",
            path: "/management/miniApp/user",
          },
          {
            id: "2-2",
            label: "入驻门店",
            routerName: "MallStore",
            path: "/management/miniApp/store",
          },
          {
            id: "2-3",
            label: "轮播图管理",
            routerName: "MiniAppBanner",
            path: "/management/miniApp/banner",
          },
          {
            id: "2-4",
            label: "公众号文章配置",
            routerName: "MiniAppArticle",
            path: "/management/miniApp/article",
          },
          // {
          //   id: "1-4-4",
          //   label: "创建账号", //包括控制门店的数量
          //   routerName: "MallAdmin",
          //   path: "/management/supAdmin/mall/admin",
          // },
        ],
      },
      //我的门店
      {
        id: "3",
        label: "我的门店",
        icon: "el-icon-s-shop",
        routerName: "Mall",
        children: [{
            id: "3-1",
            label: "门店信息",
            routerName: "StoreList",
            path: "/management/store/storeList",
          },
          // {
          //   id: "3-2",
          //   label: "员工管理", //包括门店管理
          //   routerName: "Staff",
          //   path: "/management/store/staff",
          // },
          // {
          //   id: "3-4",
          //   label: "门店商品",
          //   routerName: "Goods",
          //   children: [
          // {
          //   id: "4-4-1",
          //   label: "小程序页面设置",
          //   routerName: "GoodsKind",
          //   path: "/management/store/goods/kind",
          // },
          //   {
          //     id: "4-4-2",
          //     label: "商品分类",
          //     routerName: "GoodsKind",
          //     path: "/management/store/goods/goodsKind",
          //   },
          //   {
          //     id: "4-4-3",
          //     label: "商品列表",
          //     routerName: "GoodsList",
          //     path: "/management/store/goods/goodsList",
          //   },
          // ],
          // },
          {
            id: "3-2",
            label: "爱茶商城",
            routerName: "MallGoods",
            children: [{
                id: "3-2-1",
                label: "商品分类",
                routerName: "MallGoodsKind",
                path: "/management/store/mallGoods/goodsKind",
              },
              {
                id: "3-2--2",
                label: "商品列表",
                routerName: "MallGoodsList",
                path: "/management/store/mallGoods/goodsList",
              },
            ],
          },
          {
            id: "3-3",
            label: "积分商城",
            routerName: "IntegralGoods",
            children: [
              // {
              //   id: "4-6-1",
              //   label: "商品分类",
              //   routerName: "IntegralGoodsKind",
              //   path: "/management/store/integralGoods/goodsKind",
              // },
              {
                id: "3-3-1",
                label: "商品列表",
                routerName: "IntegralGoodsList",
                path: "/management/store/integralGoods/goodsList",
              },
            ],
          },
          //会员管理
          {
            id: "3-4",
            label: "会员管理",
            icon: "el-icon-s-custom",
            routerName: "MallVipCard",
            path: "/management/store/vipCard",
            children: [{
                id: "3-4-1",
                label: "会员列表",
                routerName: "MallVipCardList",
                path: "/management/store/vipCard/vipCardList",
              },
              {
                id: "3-4-2",
                label: "会员卡交易记录",
                routerName: "MallVipCardRecode",
                path: "/management/store/vipCard/vipCardRecode",
              },
            ],
          },
          {
            id: "3-5",
            label: "优惠券管理", //包括门店管理
            routerName: "Coupon",
            path: "/management/store/coupon",
          },
          {
            id: "3-6",
            label: "订单中心", //门店,爱茶商城,积分商城 3大类订单
            icon: "el-icon-s-order",
            routerName: "Order",
            path: "/management/store/order",
          },
        ],
      },
      //个人页
      {
        id: "4",
        label: "个人页",
        icon: "el-icon-s-custom",
        routerName: "Person",
        children: [{
          id: "8-1",
          label: "个人中心",
          routerName: "PersonCenter",
          path: "/management/person/center",
        }, ],
      },
      // {
      //   id: "7",
      //   label: "商家服务",
      //   icon: "el-icon-s-comment",
      //   routerName: "Examine",
      //   children: [
      //     {
      //       id: "7-1",
      //       label: "续费",
      //       routerName: "Payment",
      //       path: "/management/merchant/payment",
      //     },

      //     {
      //       id: "7-2",
      //       label: "使用指南",
      //       routerName: "",
      //       path: "",
      //     },
      //     {
      //       id: "7-3",
      //       label: "技术支持",
      //       routerName: "",
      //       path: "",
      //     },
      //   ],
      // },
    ],
    //登录后筛选的导航
    filterNavList: [],
    //登录后筛选的店铺列表
    filterStoreList: [],
    //高亮导航项
    active: "",
  },
  //变更状态
  mutations: {
    updataUserInfo(state, value) {
      state.userInfo = value;
    },
    updataFilterNavList(state, value) {
      state.filterNavList = value;
    },
    updataFilterStoreList(state, value) {
      state.filterStoreList = value;
    },
    updataActive(state, value) {
      state.active = value;
    },
  },
  actions: {
    /* 用户信息权限,店铺信息初始化 */
    async getUserInfoAction({
      commit,
      state,
      dispatch
    }) {
      const userInfo = await queryMyselfInfo();
      commit("updataUserInfo", userInfo.data);

      const storeList = await queryMyselfStore({
        store_id: userInfo.data.store_id || "",
      });

      commit("updataFilterStoreList", storeList.data);

      //用户无权限拦截
      if (!state.userInfo.rules) {
        return new Promise((reslove, reject) => {
          reslove({
            code: 201,
            routerName: "Errow",
            message: "当前账号权限不足",
          });
        });
      }

      //根据用户权限初始化导航数据
      var copyNavList = JSON.parse(JSON.stringify(state.navList));
      var roleList = state.userInfo.rules?.split(",");

      // console.log("copyNavList", copyNavList, "roleList======", roleList);
      await dispatch("getFilterNavListAction", {
        copyNavList,
        roleList,
      });
      commit("updataFilterNavList", copyNavList); //根据用户权限完成导航筛选

      /* 定位第一个导航 */
      const routerName = await dispatch("findFirstRouterName", copyNavList);
      return new Promise((reslove, reject) => {
        reslove({
          code: 200,
          routerName,
        });
      });
    },

    /* 导航筛选 */
    async getFilterNavListAction({
      dispatch,
      commit
    }, {
      copyNavList,
      roleList
    }) {
      for (var index = copyNavList.length - 1; index >= 0; index--) {
        if (
          copyNavList[index]?.children &&
          copyNavList[index]?.children.length > 0 &&
          roleList?.indexOf(copyNavList[index].id) >= 0
        ) {
          await dispatch("getFilterNavListAction", {
            copyNavList: copyNavList[index].children,
            roleList: roleList,
          });
        }
        if (roleList?.indexOf(copyNavList[index]?.id) < 0) {
          copyNavList.splice(index, 1);
        }
      }
    },

    /*  找到第一个导航最深层routerName */
    async findFirstRouterName({
      dispatch,
      commit
    }, copyNavList) {
      if (copyNavList[0]?.children && copyNavList[0]?.children.length > 0) {
        return await dispatch("findFirstRouterName", copyNavList[0]?.children);
      } else {
        return copyNavList[0].routerName;
      }
    },

    /* 找到导航active */
    async findActive({
      dispatch,
      commit
    }, {
      filterNavList,
      path
    }) {
      for (let index = 0; index < filterNavList.length; index++) {
        if (filterNavList[index]?.path === path) {
          commit("updataActive", filterNavList[index]?.id);
        }
        if (
          filterNavList[index]?.children &&
          filterNavList[index]?.children.length > 0 &&
          filterNavList[index]?.path !== path
        ) {
          await dispatch("findActive", {
            filterNavList: filterNavList[index]?.children,
            path,
          });
        }
      }
    },
  },

  /* 计算属性 */
  getters: {},
});
export default store;